import { fmt } from 'IntlWrapper/IntlWrapper';
import { OFD_ATTEMPT_STATES } from './dispatching';

export const FIRST_MILE_CARDS = (data, isOlderDate) => {
  const {
    minimum_predicted_deliveries_count,
    maximum_predicted_deliveries_count,
    overall_picked_up_count,
    mega_red_businesses_collected_deliveries_count,
    incoming_deliveries_count,
    incoming_routes_pickups_count
  } = data || {};
  const minPredicted = minimum_predicted_deliveries_count || 0;
  const maxPredicted = maximum_predicted_deliveries_count || 0;
  const avgPredicted = (minPredicted + maxPredicted) / 2;
  const pickedUpDeliveries =
    (overall_picked_up_count || 0) +
      mega_red_businesses_collected_deliveries_count || 0;

  const headingToSf =
    (incoming_deliveries_count || 0) + (incoming_routes_pickups_count || 0);
  return [
    {
      title: fmt({
        id: 'ops_control.overview.first_mile.Predicted_deliveries'
      }),
      min: minPredicted,
      max: maxPredicted,
      isRangeDisplay: true,
      tooltip: fmt({
        id: 'ops_control.overview.first_mile.Predicted_deliveries_tooltip'
      })
    },
    {
      title: fmt({
        id: 'ops_control.overview.first_mile.picked_up_deliveries'
      }),
      data: pickedUpDeliveries,
      tooltip: fmt({
        id: 'ops_control.overview.first_mile.picked_up_deliveries_tooltip'
      })
    },
    ...(!isOlderDate()
      ? [
          {
            title: fmt({ id: 'ops_control.overview.first_mile.heading_to_sf' }),
            data: headingToSf,
            tooltip: fmt({
              id: 'ops_control.overview.first_mile.heading_to_sf_tooltip'
            })
          }
        ]
      : [])
  ];
};

const EXPORT_RECEIVING_TYPES = {
  NEW: 'New',
  CRP: 'CRP',
  RTO: 'RTO'
};

export const MIDDLE_MILE_CARDS = (data, exportFunction, isOlderDate) => {
  const {
    overall_received_new_deliveries_count,
    overall_received_crp_deliveries_count,
    overall_received_rto_deliveries_count
  } = data || {};
  return [
    {
      title: fmt({
        id: 'ops_control.overview.middle_mile.new'
      }),
      data: overall_received_new_deliveries_count || 0,
      tooltip: fmt({
        id: 'ops_control.overview.middle_mile.new_tooltip'
      }),
      exportFunction: () => exportFunction(EXPORT_RECEIVING_TYPES.NEW)
    },
    {
      title: fmt({
        id: 'ops_control.overview.middle_mile.crp'
      }),
      data: overall_received_crp_deliveries_count || 0,
      tooltip: fmt({
        id: 'ops_control.overview.middle_mile.crp_tooltip'
      }),
      exportFunction: () => exportFunction(EXPORT_RECEIVING_TYPES.CRP)
    },
    {
      title: fmt({
        id: 'ops_control.overview.middle_mile.rto'
      }),
      data: overall_received_rto_deliveries_count || 0,
      tooltip: fmt({
        id: 'ops_control.overview.middle_mile.rto_tooltip'
      }),
      exportFunction: () => exportFunction(EXPORT_RECEIVING_TYPES.RTO)
    },
    ...(isOlderDate()
      ? [
          {
            title: fmt({
              id: 'ops_control.overview.middle_mile.received_in_lm'
            }),
            data: data?.completed_deliveries_count || 0,
            tooltip: fmt({
              id: 'ops_control.overview.middle_mile.received_in_lm_tooltip'
            })
          }
        ]
      : [])
  ];
};

export const FORWARD = 'forward';

export const LAST_MILE_CARDS = ({
  plannedDeliveres,
  stalled,
  ofdData,
  exportStallData,
  handleOfdExport,
  isOlderDate
}) => {
  const { ofd, successful, failed } = ofdData || {};
  return [
    {
      title: fmt({
        id: 'ops_control.overview.last_mile.planned_deliveries'
      }),
      data: plannedDeliveres,
      tooltip: fmt({
        id: 'ops_control.overview.last_mile.planned_deliveries_tooltip'
      })
    },
    ...(!isOlderDate()
      ? [
          {
            title: fmt({
              id: 'ops_control.overview.last_mile.ofd'
            }),
            data: ofd || 0,
            tooltip: fmt({
              id: 'ops_control.overview.last_mile.ofd_tooltip'
            }),
            exportFunction: () => handleOfdExport(OFD_ATTEMPT_STATES[0].value)
          }
        ]
      : []),
    {
      title: fmt({
        id: 'ops_control.overview.last_mile.delivered'
      }),
      data: successful || 0,
      tooltip: fmt({
        id: 'ops_control.overview.last_mile.delivered_tooltip'
      }),
      exportFunction: () => handleOfdExport(OFD_ATTEMPT_STATES[2].value)
    },
    {
      title: fmt({
        id: 'ops_control.overview.last_mile.failed'
      }),
      data: failed || 0,
      tooltip: fmt({
        id: 'ops_control.overview.last_mile.failed_tooltip'
      }),
      exportFunction: () => handleOfdExport(OFD_ATTEMPT_STATES[1].value)
    },
    {
      title: fmt({
        id: 'ops_control.overview.last_mile.stalled'
      }),
      data: stalled,
      tooltip: fmt({
        id: 'ops_control.overview.last_mile.stalled_tooltip'
      }),
      exportFunction: () => exportStallData()
    }
  ];
};
